<div class="sqs-message-dialog">
  <div class="dialog-header">
    <h3>
      <i class="pi pi-envelope" style="margin-right: 8px;"></i>
      Mensagem{{ hasMultipleMessages ? 's' : '' }} SQS
      <span *ngIf="hasMultipleMessages" class="message-count">({{ sqsMessages.length }} encontradas)</span>
    </h3>
    <div class="dialog-actions">
      <button
        pButton
        type="button"
        icon="pi pi-copy"
        label="Copiar"
        class="p-button-sm p-button-outlined"
        (click)="copyToClipboard()">
      </button>
      <button
        pButton
        type="button"
        icon="pi pi-replay"
        label="Reenviar para Fila"
        class="p-button-sm p-button-success"
        [disabled]="resending || !sqsMessageId || sqsMessageId === 'N/A'"
        (click)="resendToQueue()">
      </button>
      <button
        pButton
        type="button"
        icon="pi pi-times"
        label="Fechar"
        class="p-button-sm"
        (click)="close()">
      </button>
    </div>
  </div>


  <div *ngIf="hasMultipleMessages" class="messages-list">
    <div class="messages-tabs">
      <div
        *ngFor="let msgItem of sqsMessages; let i = index"
        class="message-tab"
        [ngClass]="{'active': selectedMessageIndex === i}"
        (click)="selectMessage(i)">
        <span class="tab-number">Mensagem {{ msgItem.index }}</span>
        <span *ngIf="msgItem.errorType" class="tab-error-badge">{{ msgItem.errorType }}</span>
        <span *ngIf="msgItem.createdAt" class="tab-date">{{ formatDate(msgItem.createdAt) }}</span>
      </div>
    </div>
  </div>


  <div *ngIf="sqsMessages.length > 0" class="message-info">
    <div *ngIf="hasMultipleMessages" class="message-header-info">
      <div class="info-item">
        <i class="pi pi-info-circle"></i>
        <span>Exibindo Mensagem {{ selectedMessageIndex + 1 }} de {{ sqsMessages.length }}</span>
      </div>
      <div *ngIf="sqsMessages[selectedMessageIndex].createdAt" class="info-item">
        <i class="pi pi-calendar"></i>
        <span>Criado em: {{ formatDate(sqsMessages[selectedMessageIndex].createdAt) }}</span>
      </div>
      <div *ngIf="sqsMessages[selectedMessageIndex].errorMessage" class="info-item error">
        <i class="pi pi-exclamation-triangle"></i>
        <span>Erro: {{ sqsMessages[selectedMessageIndex].errorMessage }}</span>
      </div>
    </div>
  </div>

  <div class="message-content">
    <pre class="json-content">{{ currentFormattedMessage }}</pre>
  </div>
</div>
